import type {IHighlightRange} from "../types/IHighlightRange";
import {normalizeForMatch} from "./normalize_for_match";

const TOKEN_SEPARATOR = /[\s,]+/;

const isWordChar = (char: string): boolean => /[0-9]/.test(char) || char.toLowerCase() !== char.toUpperCase();

const trimToWordChars = (token: string): string => {
    let start = 0;
    let end = token.length;

    while (start < end && !isWordChar(token.charAt(start))) {
        start++;
    }
    while (end > start && !isWordChar(token.charAt(end - 1))) {
        end--;
    }

    return token.slice(start, end);
};

const isWordStart = (text: string, index: number): boolean => index === 0 || !isWordChar(text.charAt(index - 1));

const mergeRanges = (ranges: IHighlightRange[]): IHighlightRange[] => {
    const sorted = ranges.slice().sort((a, b) => a.start - b.start || a.end - b.end);
    const merged: IHighlightRange[] = [];

    for (const range of sorted) {
        const last = merged[merged.length - 1];

        if (last && range.start <= last.end) {
            last.end = Math.max(last.end, range.end);
        } else {
            merged.push({start: range.start, end: range.end});
        }
    }

    return merged;
};

/**
 * Finds where the query tokens match the starts of words in `text`, ignoring case and diacritics
 * ("Bie" → **Bie**lańska, "lodz" → **Łódź**, "łódz" → **Łódz**ka). Every occurrence counts; the result is sorted
 * and overlapping or touching ranges are merged.
 */
export const getHighlightRanges = (text: string, query: string): IHighlightRange[] => {
    const normalizedText = normalizeForMatch(text);
    const tokens = query
        .split(TOKEN_SEPARATOR)
        .map((token) => normalizeForMatch(trimToWordChars(token)))
        .filter((token) => token.length > 0);

    const ranges: IHighlightRange[] = [];

    for (const token of tokens) {
        let index = normalizedText.indexOf(token);

        while (index !== -1) {
            if (isWordStart(text, index)) {
                ranges.push({start: index, end: index + token.length});
            }
            index = normalizedText.indexOf(token, index + 1);
        }
    }

    return mergeRanges(ranges);
};
import type {IHighlightRange} from "../types/IHighlightRange";
import {normalizeForMatch} from "./normalize_for_match";

const TOKEN_SEPARATOR = /[\s,]+/;

const isWordChar = (char: string): boolean => /[0-9]/.test(char) || char.toLowerCase() !== char.toUpperCase();

const trimToWordChars = (token: string): string => {
    let start = 0;
    let end = token.length;

    while (start < end && !isWordChar(token.charAt(start))) {
        start++;
    }
    while (end > start && !isWordChar(token.charAt(end - 1))) {
        end--;
    }

    return token.slice(start, end);
};

const isWordStart = (text: string, index: number): boolean => index === 0 || !isWordChar(text.charAt(index - 1));

const mergeRanges = (ranges: IHighlightRange[]): IHighlightRange[] => {
    const sorted = ranges.slice().sort((a, b) => a.start - b.start || a.end - b.end);
    const merged: IHighlightRange[] = [];

    for (const range of sorted) {
        const last = merged[merged.length - 1];

        if (last && range.start <= last.end) {
            last.end = Math.max(last.end, range.end);
        } else {
            merged.push({start: range.start, end: range.end});
        }
    }

    return merged;
};

/**
 * Finds where the query tokens match the starts of words in `text`, ignoring case and diacritics
 * ("Bie" → **Bie**lańska, "lodz" → **Łódź**, "łódz" → **Łódz**ka). Every occurrence counts; the result is sorted
 * and overlapping or touching ranges are merged.
 */
export const getHighlightRanges = (text: string, query: string): IHighlightRange[] => {
    const normalizedText = normalizeForMatch(text);
    const tokens = query
        .split(TOKEN_SEPARATOR)
        .map((token) => normalizeForMatch(trimToWordChars(token)))
        .filter((token) => token.length > 0);

    const ranges: IHighlightRange[] = [];

    for (const token of tokens) {
        let index = normalizedText.indexOf(token);

        while (index !== -1) {
            if (isWordStart(text, index)) {
                ranges.push({start: index, end: index + token.length});
            }
            index = normalizedText.indexOf(token, index + 1);
        }
    }

    return mergeRanges(ranges);
};
